<template>
  <q-footer elevated class="bg-secondary text-white q-pt-md q-mt-lg">
    <div class="row full-width justify-center">
      <a
        class="text-white q-pa-sm"
        href="https://www.talentsconnect.com/impressum"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t('message.legalNoticeFLbl') }}</a
      ><a
        class="text-white q-pa-sm"
        href="https://www.talentsconnect.com/datenschutzerklaerung"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t('message.privacyPolicyFLbl') }}</a
      ><a
        v-show="showTermsOfUse"
        class="text-white q-pa-sm"
        href="https://www.pitchyou.de/nutzungsbedingungen"
        target="_blank"
        rel="noopener noreferrer"
        >{{ $t('message.termsOfUseFLbl') }}</a
      >
    </div>
    <div class="copyright text-center q-pa-md q-mt-xs bg-secondary">
      &copy; {{ currentYear() }}  TalentsConnect Operations GmbH
    </div>
  </q-footer>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';

const name = 'BrandFooter';
const { showTermsOfUse } = defineProps(['showTermsOfUse']);

function currentYear() {
  return new Date().getFullYear();
}

</script>

<style></style>
